interface IntercomUserTraits {
  userId: string
  email?: string
  name?: string
  tenantId?: string
  tenantName?: string
}

let _appId: string | undefined | null = null
const getAppId = (): string | undefined => {
  if (_appId === null) {
    _appId = useRuntimeConfig().public.intercomAppId as string | undefined
  }
  return _appId
}

export default function useIntercom () {
  const appId = getAppId()

  const getIntercom = (): NonNullable<Window['Intercom']> | null => {
    return appId && typeof window.Intercom === 'function' ? window.Intercom : null
  }

  const isEnabled = () => !!getIntercom()

  const identify = ({ userId, email, name, tenantId, tenantName }: IntercomUserTraits) => {
    const intercom = getIntercom()
    if (!intercom) { return }
    intercom('update', {
      app_id: appId,
      user_id: userId,
      email,
      name,
      hide_default_launcher: true,
      ...(tenantId && {
        company: tenantName
          ? { company_id: tenantId, name: tenantName }
          : { company_id: tenantId }
      })
    })
  }

  const shutdown = () => {
    const intercom = getIntercom()
    if (!intercom) { return }
    intercom('shutdown')
    intercom('boot', { app_id: appId, hide_default_launcher: true })
  }

  const show = () => {
    getIntercom()?.('show')
  }

  return { isEnabled, identify, shutdown, show }
}
